import angular from 'angular'
import { setting } from 'redevConfig'
const page = (setting && setting.page) || ''

const settingPage = page ? require(`redevelopment/main/setting/${page.templateName}`) : require('./views/menuset.html')
const menusetCtrl = page ? require(`redevelopment/main/setting/${page.controllerName}`) : require('./menusetCtrl')
export default angular
    .module('app.setting', [])
    .config(['$stateProvider', function config ($stateProvider) {
        $stateProvider.state('index.menuset', {
            url: '/menuset',
            template: settingPage,
            controller: 'menusetCtrl',
            title: '常用菜单设置',
        })
    }])
    .controller('menusetCtrl', menusetCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/main/setting/index.js